import { render, staticRenderFns } from "./TabInformation.vue?vue&type=template&id=155e110b&scoped=true"
import script from "./TabInformation.vue?vue&type=script&lang=ts"
export * from "./TabInformation.vue?vue&type=script&lang=ts"
import style0 from "./TabInformation.vue?vue&type=style&index=0&id=155e110b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155e110b",
  null
  
)

export default component.exports